module.exports = __webpack_public_path__ + "img/nucleus1.bb841676.png";